// Leave a Jitsi call properly before its window goes away. Removing the
// iframe without hanging up leaves a "ghost" in the room for about a minute
// (Prosody keeps the session in case it reconnects): rooms are capped at two,
// so the person couldn't rejoin ("maximum participants"), and the other side
// still saw them as present.
export function leaveJitsi(api, waitMs = 1500) {
  if (!api) return Promise.resolve();
  return new Promise((resolve) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      try { api.dispose(); } catch (e) { /* already gone */ }
      resolve();
    };
    try { api.addListener('videoConferenceLeft', finish); } catch (e) { /* ignore */ }
    try { api.executeCommand('hangup'); } catch (e) { finish(); return; }
    setTimeout(finish, waitMs);
  });
}

// Best effort when the page itself is closing: there's no time to wait.
export function hangupNow(api) {
  try { api?.executeCommand('hangup'); } catch (e) { /* already gone */ }
}
